export default __webpack_public_path__ + "static/media/calendar-dashboard.10ec3d95.svg";